export default __webpack_public_path__ + "2e07bd066ffd24c2b92668f772a8f300.svg";